import {
    Component, Input, OnInit, ViewEncapsulation, EventEmitter, Output,
    OnChanges,
    SimpleChanges,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';

import { WLItem } from '../../../domain/models/wishlist.models';
import { WishlistCommandsFacade } from '../../../infrastructure/facades/commands/wishlist.commands.facade';

import { Product } from '@api/catalog/products/products.models'; // TODO ECOMDUTI-18308 [TechDebt]: [REFACTOR] Clean Arquitecture Feature Producto
import { AnalyticsCartAction, AnalyticsCartCategory, AnalyticsCartCF } from '@shared/analytics/constants/cart/analytics-cart.constants';
import { ControlCartAnalytics } from '@shared/analytics/store/app-events-analytics.actions';

@Component({
    selector: 'wishlist-icon',
    templateUrl: './wishlist-icon.component.html',
    styleUrls: ['./wishlist-icon.component.scss'],
    // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistIconComponent implements OnInit, OnChanges {
    @Input() public isProductDetail: boolean = false; // TODO ECOMDUTI-20984 [TechDebt]: Desacoplar analitica Wishlist (Eliminar)

    @Input() public product: Product;

    @Input() public wishlistItems: Product[];

    @Output() public readonly addToWhislistClicked: EventEmitter<boolean> = new EventEmitter();

    public isOnWishlist: boolean = false;

    public itemWL: WLItem;

    public sku: string;

    constructor(
        private readonly store: Store,
        private readonly wishlistCommandsFacade: WishlistCommandsFacade,
    ) { }

    public ngOnInit(): void {
        this.wishlistCommandsFacade.loadWishlistAction();
        this.initWishlist();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.product?.currentValue) {
            this.updateSkuFromProduct();
        }
        this.initWishlist();
    }

    private getSkuFromWish(product, wishlistItems): { skusFromWish: string; selectedSizeSku: string } {
        const productSkus = product.status.selectedColor?.sizes.map(size => size.sku) || [];
        const wishlistSkus = wishlistItems.flatMap(item => item.status.selectedSize.sku);
        const skusFromWish = productSkus.filter(sku => wishlistSkus.includes(sku)).toString();
        const selectedSizeSku = product.status?.selectedSize?.sku.toString();
        return { skusFromWish, selectedSizeSku };
    }

    private updateSkuFromProduct(): void {
        const product = this.product;
        if (product) {
            const { skusFromWish, selectedSizeSku } = this.getSkuFromWish(product, this.wishlistItems);
            this.sku = selectedSizeSku || skusFromWish;
        }
    }

    public initWishlist(): void {
        if (this.sku === '') {
            const fistsizeSku = this.product.status?.selectedColor?.sizes[0]?.sku;
            this.sku = fistsizeSku.toString();
        }

        this.itemWL = {
            catentryId: Number(this.sku),
            productId: Number(this.product?.id),
            quantity: 1,
        };

        this.checkWishlistAdd();
    }

    public clickWishlist(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();
        this.wishlistControl();
    }

    private checkWishlistAdd(): void {
        const { skusFromWish, selectedSizeSku } = this.getSkuFromWish(this.product, this.wishlistItems);
        this.isOnWishlist = skusFromWish !== '';

        if (selectedSizeSku && !skusFromWish.includes(selectedSizeSku)) {
            this.isOnWishlist = false;
        }
    }

    private wishlistControl(): void {
        if (this.isOnWishlist) {
            this.deleteItemWishlist();
        } else {
            this.addItemWishlist();
        }
    }

    private addItemWishlist(): void {
        this.dispatchAnalytics(AnalyticsCartAction.addToWishlist);
        const itemWishlist = { ...this.product, ...this.itemWL };
        this.wishlistCommandsFacade.addItemsWishlistAction(
            { items: [{ item: itemWishlist, sku: Number(this.sku) }], deleteItemCart: false }
        );
        this.addToWishlistClick(true);
    }

    public addToWishlistClick(value: boolean) {
        this.addToWhislistClicked.emit(value);
    }

    private deleteItemWishlist(): void {
        const itemToDelete: WLItem = {
            catentryId: this.itemWL.catentryId.toString(),
            productId: this.itemWL.productId.toString(),
        };
        this.dispatchAnalytics(AnalyticsCartAction.removeFromWishlist);
        this.wishlistCommandsFacade.deleteItemWishlistAction(itemToDelete);
        this.addToWishlistClick(false);
    }

    // TODO ECOMDUTI-20984 [TechDebt]: Desacoplar analitica Wishlist
    private dispatchAnalytics(action: AnalyticsCartAction): void {
        this.store.dispatch(
            ControlCartAnalytics({
                cf: AnalyticsCartCF.wishList,
                category: this.isProductDetail ? AnalyticsCartCategory.fichaProducto : AnalyticsCartCategory.parrilla,
                action: action,
                product: this.product,
                needsEcommerce: false,
            }),
        );
    }
}
